/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reject_RequestInputs */

const en_reject_request = /** @type {(inputs: Reject_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject`)
};

const es_reject_request = /** @type {(inputs: Reject_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const fr_reject_request = /** @type {(inputs: Reject_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeter`)
};

const de_reject_request = /** @type {(inputs: Reject_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

const id_reject_request = /** @type {(inputs: Reject_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

/** @type {(inputs: Reject_RequestInputs) => LocalizedString} */
const ja_reject_request = en_reject_request;

/** @type {(inputs: Reject_RequestInputs) => LocalizedString} */
const zh_reject_request = en_reject_request;

/** @type {(inputs: Reject_RequestInputs) => LocalizedString} */
const ar_reject_request = en_reject_request;

/** @type {(inputs: Reject_RequestInputs) => LocalizedString} */
const it_reject_request = en_reject_request;

/** @type {(inputs: Reject_RequestInputs) => LocalizedString} */
const ru_reject_request = en_reject_request;

/** @type {(inputs: Reject_RequestInputs) => LocalizedString} */
const pt_reject_request = en_reject_request;

/** @type {(inputs: Reject_RequestInputs) => LocalizedString} */
const ko_reject_request = en_reject_request;

/**
* | output |
* | --- |
* | "Reject" |
*
* @param {Reject_RequestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reject_request = /** @type {((inputs?: Reject_RequestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reject_RequestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reject_request(inputs)
	if (locale === "es") return es_reject_request(inputs)
	if (locale === "fr") return fr_reject_request(inputs)
	if (locale === "de") return de_reject_request(inputs)
	if (locale === "ja") return ja_reject_request(inputs)
	if (locale === "zh") return zh_reject_request(inputs)
	if (locale === "ar") return ar_reject_request(inputs)
	if (locale === "id") return id_reject_request(inputs)
	if (locale === "it") return it_reject_request(inputs)
	if (locale === "ru") return ru_reject_request(inputs)
	if (locale === "pt") return pt_reject_request(inputs)
	return ko_reject_request(inputs)
});